import { render, staticRenderFns } from "./v-ribbon.vue?vue&type=template&id=3419f46e&scoped=true&"
import script from "./v-ribbon.vue?vue&type=script&lang=js&"
export * from "./v-ribbon.vue?vue&type=script&lang=js&"
import style0 from "./v-ribbon.vue?vue&type=style&index=0&id=3419f46e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3419f46e",
  null
  
)

export default component.exports